<div class="dialog">
    <div class="dialog-title">
        <h4 class="semi-bold">AWB Tracking No <img src="assets/svg/close-white.svg" alt="close" (click)="close()"></h4>
    </div>
    <div class="content custom-form">
        <input type="text" [(ngModel)]="awbNumber">
    </div>
    <div class="button text-center">
        <button class="orange" (click)="update()">Update</button>
    </div>
</div>